import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentServicingComponent } from 'app/partials/content-servicing/content-servicing.component';
import { MetafrenzyGuard } from 'ngx-metafrenzy';
import { ServicingService } from './servicing.service';

const routes: Routes = [
  {
    path: ':id',
    component: ContentServicingComponent,
    canActivate: [MetafrenzyGuard],
    resolve: { data: ServicingService },
    data: {
      metafrenzy: {}
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServicingRoutingModule {}
